import { render, staticRenderFns } from "./SwipeBanner.vue?vue&type=template&id=49418e6e&scoped=true&"
import script from "./SwipeBanner.vue?vue&type=script&lang=js&"
export * from "./SwipeBanner.vue?vue&type=script&lang=js&"
import style0 from "./SwipeBanner.vue?vue&type=style&index=0&id=49418e6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49418e6e",
  null
  
)

export default component.exports